
/* import subComponents */
import { CarouselLocals } from '../subComponents/CarouselLocals';
/* import CSS */
import "./styles/Focus5.css"
 
import rachidApec from "../assets/Rachid_sosjp_Apec.mp4"
import rachidTrophy from '../assets/poster.jpeg'
import djamelThumbnail from "../assets/djamel_Adie_Sosjp_entrepreneur_grenoble_echirolles.avif"
import djamel from '../assets/Djamel.mp4'

export const Focus5 = () => {
    const alt_name = "Mefaireaccompagner-accompagnement-entrepreneuriat-entreprendre-financement-qpv-villedegrenoble-villedechirolles-villedefontaine-villedepontdeclaix-aceisp-grenoble-gaia-grenoble-adie-grenoble-cci-grenoble-frenchtech-alps-grenoble-cma-grenoble-cap-berriat-grenoble-sosjeunespousses-grenoble-citeslab-grenoble-bpifrance-grenoble-grenoble-alpes-metropole"
    const images = require.context('../assets/locaux/all/1.33/avif/', true);
    const imageList_1 = images.keys().map(image =><img src={images(image)} className='CarouselLocal_img_ver' loading="eager" alt={alt_name}/> );
    
    const images_2 = require.context('../assets/locaux/all/0.75/avif/', true);
    const imageList_2 = images_2.keys().map(image =><img src={images_2(image)} className='CarouselLocal_img_hor' loading="eager" alt={alt_name}/> );

    let first_slice = imageList_1.splice(0,Math.ceil(imageList_1.length/2))

    /* compute slide per view to let 10 px exactly */
    let height = window.innerHeight*8/10;
    let width = window.innerWidth;
    
    let block_1_unit_height = (width*2/10)/1.33;    
    let block_2_unit_height = (width*25/100)/0.75;

    let slides_1_count = height/(block_1_unit_height+20)
    let slides_2_count = height/(block_2_unit_height+20)
    return(
        <div className='Focus5_Container'>
                <div className='CarouselContainer' >
                <CarouselLocals className='SwipperCarousel_1' items={imageList_1} vertical={true} reverseDirection={false} speed='12000' spaceBetween='20px' slidesPerView={slides_1_count}/>
                <CarouselLocals className='SwipperCarousel_2' items={imageList_2} vertical={true} reverseDirection={true} speed='12000' spaceBetween='20px' slidesPerView={slides_2_count}/>
                <CarouselLocals className='SwipperCarousel_3' items={first_slice} vertical={true} reverseDirection={false} speed='12000' spaceBetween='20px' slidesPerView={slides_1_count}/>

                </div>


                <div style={{display: 'flex'}}>
                <div className='Focus5_Videos_Container'>

                <video id="samp" controls poster={rachidTrophy}>
                <source src={rachidApec} type="video/mp4">
                </source>
                </video>

                <video id="samp2" alt="djamel_Adie_Sosjp_entrepreneur_grenoble_echirolles" controls poster={djamelThumbnail}>
                <source src={djamel} type="video/mp4">
                </source>
                </video>
                </div>



                </div>
        </div>
    )
}